import { StudyPlanningInfo } from '@/models/studyPlanning/StudyPlanningModel';
import { WeekInfo } from '@/models/studyPlanning/WeekModel';
import { ListInfo } from '@/models/studyPlanning/ListModel';
import { StudyPlanningBreakpointInfo } from '@/models/studyPlanning/StudyPlanningBreakpointModel';
import { StudyPlanningChimeraContractInfo } from '@/models/studyPlanning/StudyPlanningContractModel';

export interface StudyPlanningState {
  studyPlanning: StudyPlanningInfo | null;
  currentWeek: WeekInfo | null;
  anticipatedWeeks: { [weekId: string]: WeekInfo };
  weekLists: ListInfo[];
  anticipatedWeeksListsByWeekId: { [weekId: string]: ListInfo[] };
  breakpoints: { [numberOfMonths: string]: StudyPlanningBreakpointInfo };
  extensionBreakpoints: { [numberOfMonths: string]: StudyPlanningBreakpointInfo };
  chimeraContract: StudyPlanningChimeraContractInfo | null;
}

const state: StudyPlanningState = {
  studyPlanning: null,
  currentWeek: null,
  anticipatedWeeks: {},
  weekLists: [],
  anticipatedWeeksListsByWeekId: {},
  breakpoints: {},
  extensionBreakpoints: {},
  chimeraContract: null,
};

export default state;
